'use client'

import { Gift } from "lucide-react";
import { usePlatformFlags } from "~/lib/use-platform-flags";
import {
  SIGNUP_INCENTIVE_LEAD_NO_OFFER,
  SIGNUP_INCENTIVE_REST,
  feeWaiverLead,
} from "./signup-incentive";

export {
  SIGNUP_INCENTIVE_REST,
  SIGNUP_INCENTIVE_LEAD_NO_OFFER,
  signupIncentiveCopy,
} from "./signup-incentive";

/**
 * Branded incentive callout (Path Collective visual system: warm gold field,
 * terracotta/gold gift badge, rounded body copy).
 *
 * #1326 — the fee-waiver line is read from `GET /platform/flags` and is shown
 * only while the waiver is on, in the admin-managed wording. The flags call is
 * unauthenticated and happens client-side, so the anonymous discovery render
 * stays free of it (see the load-test note in docs/ROADMAP.md).
 */
export function SignupIncentiveNote({ className = "" }: { className?: string }) {
  const { fee_waiver_enabled, fee_waiver_message, loaded } = usePlatformFlags();
  const lead = feeWaiverLead({
    enabled: fee_waiver_enabled,
    message: fee_waiver_message,
    loaded,
  });

  return (
    <div
      className={`flex gap-3 rounded-2xl border border-[#EAD9A6] bg-gradient-to-br from-[#FBEFD3] to-[#F7E7CE] p-4 text-left ${className}`}
    >
      <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-[#F0B853] text-[#7A5414] shadow-[inset_0_0_0_1.5px_#D99E37]">
        <Gift className="h-[18px] w-[18px]" />
      </div>
      <p className="font-[family-name:var(--font-nunito)] text-[13px] leading-relaxed text-[#5E4B2E]">
        <span className="font-bold text-[#2C2D2B]">
          {lead ?? SIGNUP_INCENTIVE_LEAD_NO_OFFER}
        </span>{" "}
        {SIGNUP_INCENTIVE_REST}
      </p>
    </div>
  );
}
